import { useLanguage } from "@utils/hooks/useLanguage";
import { useTranslations } from "../../../../../translation/TranslationContext";

interface AddedTimeBarProps {
    minutes: number;
}

const AddedTimeBar = ({ minutes }: AddedTimeBarProps) => {
        const language = useLanguage();
        const t = useTranslations(language); 

    return (
        <div className='w-full h-[16px] font-unibetRegular font-normal text-[12px] leading-[16px] 
        text-monoX dark:text-monoY bg-transparent mb-[8px] flex items-center justify-center'>
            <div>{`+${minutes} ${t[`InHouseStats.OverviewAddedTimeMinutes`]}`}</div>
        </div>
    )
}

export default AddedTimeBar;